import type { ValidatorConstraintInterface } from "class-validator";
import { ValidatorConstraint } from "class-validator";

@ValidatorConstraint({ name: "is Geo Json Polygon Type" })
export class IsGeofenceType implements ValidatorConstraintInterface {
  public validate(value: any): boolean {
    if (!value) {
      return false;
    }
    if (typeof value !== "string") {
      return false;
    }
    if (value !== "Polygon") {
      return false;
    }
    return true;
  }

  public defaultMessage(): string {
    return "Invalid Geo JSON Polygon Type format.";
  }
}
